module.exports = __webpack_public_path__ + "static/assets/12533519dd0802f603e692afc907ef52.png";